<template>
  <nav
    aria-label="Global"
    class="mx-auto flex max-w-7xl items-center justify-between p-4 lg:px-8"
  >
    <div class="flex items-center gap-x-6 xl:gap-x-10">
      <nuxt-link
        to="/"
        class="-m-1.5 shrink-0 p-1.5"
      >
        <span class="sr-only">
          {{ appName }}
        </span>

        <img
          :alt="appLogoAlt"
          :src="appLogoUrl"
          class="h-8 w-auto"
        />
      </nuxt-link>

      <div class="hidden lg:flex lg:gap-x-5 xl:gap-x-8">
        <nuxt-link
          v-for="item in navHeaderItems"
          :key="item.name"
          :to="item.href"
          class="whitespace-nowrap text-sm/6 font-semibold text-gray-700 bg-gradient-to-r from-current to-current bg-left-bottom bg-no-repeat bg-[length:0%_1px] transition-[background-size,color] duration-200 ease-out hover:bg-[length:100%_1px] hover:text-brand-700 active:text-brand-700 motion-reduce:transition-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600"
        >
          {{ item.name }}
        </nuxt-link>
      </div>
    </div>

    <div class="flex lg:hidden">
      <button
        type="button"
        class="-m-2.5 inline-flex items-center justify-center rounded-xl p-2.5 text-gray-900 hover:text-brand-700 hover:bg-brand-50 active:bg-brand-50 transition"
        @click.prevent="emit('open', true)"
      >
        <span class="sr-only">
          Ouvrir le menu
        </span>

        <icon
          name="ph:list"
          aria-hidden="true"
          class="size-6"
        />
      </button>
    </div>

    <div class="hidden shrink-0 lg:flex lg:items-center lg:gap-x-3 xl:gap-x-4">
      <button-secondary
        :link="appUrl"
        target="_blank"
        label="Se connecter"
        size="sm"
        class="whitespace-nowrap"
      />

      <button-primary
        link="/demo"
        label="Demander une démo"
        size="sm"
      />
    </div>
  </nav>
</template>

<script setup lang="ts">
import type { NavDesktopEmits } from 'types/navigation'

const emit = defineEmits<NavDesktopEmits>()

const config = useRuntimeConfig()
const env = config.public
const appUrl = env.APP_URL
</script>
